import { render, staticRenderFns } from "./customReport.vue?vue&type=template&id=615ab515&scoped=true&"
import script from "./customReport.vue?vue&type=script&lang=js&"
export * from "./customReport.vue?vue&type=script&lang=js&"
import style0 from "./customReport.vue?vue&type=style&index=0&id=615ab515&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "615ab515",
  null
  
)

component.options.__file = "customReport.vue"
export default component.exports